module.exports = __webpack_public_path__ + "img/ethsign.663064c2.png";